<div class="modal fade" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {{title}}
                </h4>    
                <h6 class="modal-subtitle mb-0">
                    {{subtitle}}
                </h6>    
            </div>
            <div class="modal-body">
               <form #form="ngForm" novalidate>
                    <sgt-loading-info
                        *ngIf="isLoading"
                        title="Carregando os usuários"
                        text="Aguarde um momento enquanto estamos carregando os usuários">
                    </sgt-loading-info> 

                    <ng-template [ngIf]="isLoadingFinished">
                         <div class="row" *ngIf="possuiAgrupamentos()">
                            <div class="col-12">

                                 <div class="card" *ngFor="let agrupamentoPopula of agrupamentosPopula; let indexAgrupamento = index">
                                     <div class="card-header">
                                         {{agrupamentoPopula.nomePerfil}}
                                     </div>                                
                                     <ul class="list-group list-group-flush">
                                         <li class="list-group-item" *ngFor="let entityPopula of agrupamentoPopula.usuarios; let indexEntity = index"
                                             [class.exists]="entityPopula.exists">
                                             
                                             <div class="list-group-item-content">
                                                 <p class="mb-0">{{entityPopula.usuario?.nome}}</p>
                                                 <small class="text-muted">{{entityPopula.usuario?.login}}</small>
                                             </div>

                                             <div class="list-group-item-controls">
                                                 <div class="custom-control custom-switch float-right" *ngIf="!entityPopula.exists">
                                                     <input type="checkbox" class="custom-control-input" [(ngModel)]="entityPopula.selected" name="entityPopulaSelected_{{indexAgrupamento}}_{{indexEntity}}" id="entityPopulaSelected_{{indexAgrupamento}}_{{indexEntity}}"
                                                        (ngModelChange)="onChangeSelected()">
                                                     <label class="custom-control-label" for="entityPopulaSelected_{{indexAgrupamento}}_{{indexEntity}}"></label>
                                                 </div>     
                                                 <div class="float-right label-exists" *ngIf="entityPopula.exists">
                                                     Já adicionado
                                                 </div>                                    
                                            </div>                                             
    
                                         </li>
                                     </ul>
                                 </div>                            
                            </div>
                        </div>
     
                        <div class="alert alert-info alert-no-entities" *ngIf="!possuiAgrupamentos()">
                             <h5>
                                <i class="fas fa-info" aria-hidden="true"></i> Nenhum usuário cadastrado
                             </h5>
                             <p>É necessário cadastrar os usuários para poder adicionar</p>
                         </div>
                    </ng-template>
                                
               </form>
            </div>
            <div class="modal-footer">
                <div class="modal-footer-controls">
                    <div class="custom-control custom-switch float-left" *ngIf="possuiAgrupamentos()">
                        <input type="checkbox" class="custom-control-input" [(ngModel)]="allSelected" name="allSelected" id="allSelected"
                            (ngModelChange)="onChangeAllSelected($event)">
                        <label class="custom-control-label" for="allSelected">Selecionar todos os usuários</label>
                    </div>
                </div>

                <div class="modal-footer-btns">
                    <button type="button" class="btn btn-light mr-2" (click)="close()">
                        Cancelar
                    </button>
                    <button type="button" class="btn btn-primary" (click)="adicionarClick()" id="btnAdicionarusuarios" *ngIf="possuiAgrupamentos()">
                        Adicionar
                    </button>                
                </div>
            </div>            
        </div>
    </div>
</div>